// frontend/src/components/HeroSlider.jsx
import React, { useState, useEffect } from "react";

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      id: 1,
      title: "Welcome to Drive With Portland ",
      description:
        "Fast, secure, and easy application with step-by-step guidance.",
      bgImage: "/img/slide-1.avif",
    },
    {
      id: 2,
      title: "Welcome to Drive With Portland",
      description:
        "Fast, secure, and easy application with step-by-step guidance.",
      bgImage: "/img/slide-2.avif",
    },
    {
      id: 3,
      title: "Welcome to Drive With Portland",
      description:
        "Fast, secure, and easy application with step-by-step guidance.",
      bgImage: "/img/slide-3.avif",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section
      id="hero"
      className="relative h-[90vh] sm:h-[95vh] lg:h-screen pt-[80px] md:pt-[160px] overflow-hidden"
    >
      <div className="slider relative h-full w-full">
        <div
          className="slider-track flex transition-transform duration-1000 ease-in-out h-full"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide) => (
            <div
              key={slide.id}
              className="slide relative w-full flex-shrink-0 h-full"
            >
              <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${slide.bgImage}')`,
                  animation: "backgroundPan 20s linear infinite",
                }}
              ></div>
              <div className="absolute inset-0 bg-black/40"></div>
              <div className="relative z-10 w-full max-w-7xl mx-auto h-full flex flex-col lg:flex-row items-center justify-center px-4 sm:px-6 lg:px-8 py-4 sm:py-8 lg:py-0">
                <div className="w-full lg:w-1/2 text-center lg:text-left space-y-3 sm:space-y-4 md:space-y-6 text-white animate-fadeInUp mt-4 sm:mt-8 lg:mt-0">
                  <h1 className="text-3xl xs:text-4xl sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl font-extrabold drop-shadow-lg leading-tight sm:leading-tight md:leading-tight">
                    {slide.title}
                  </h1>
                  <p className="text-base sm:text-lg md:text-xl lg:text-xl text-gray-200 drop-shadow-md max-w-2xl mx-auto lg:mx-0 px-2 sm:px-0">
                    {slide.description}
                  </p>
                </div>

                <div className="w-full lg:w-[50%] flex justify-center items-center relative mt-6 sm:mt-8 md:mt-10 lg:mt-0">
                  <div
                    className="relative w-full max-w-xs  xs:max-w-sm sm:max-w-md md:max-w-lg lg:max-w-md xl:max-w-lg mx-auto  lg:mx-0 lg:absolute lg:left-8 xl:left-16 bg-gradient-to-tr from-blue-600/40 to-purple-700/30 backdrop-blur-2xl rounded-3xl shadow-2xl  p-1 sm:p-10 md:p-3 lg:p-1 xl:p-4 text-center transform hover:scale-[1.02] lg:hover:scale-105 transition-all duration-300 z-20 cursor-pointer ring-1 ring-white/20 hover:ring-white"
                    onClick={() =>
                      document
                        .getElementById("contact")
                        ?.scrollIntoView({ behavior: "smooth" })
                    }
                  >
                    <div className="w-8 h-8 xs:w-24 xs:h-24  sm:w-28 sm:h-28 md:w-32 md:h-32 lg:w-24 lg:h-24 xl:w-32 xl:h-32 mx-auto mb-3 sm:mb-4 flex items-center justify-center rounded-xl shadow-lg bg-white/20 hover:bg-white/30 transition">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-10 h-10 xs:w-12 xs:h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 lg:w-12 lg:h-12 xl:w-16 xl:h-16 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M16 21v-2a4 4 0 00-8 0v2M12 11a4 4 0 100-8 4 4 0 000 8z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-white font-bold  text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-xl xl:text-2xl mb-2">
                      Contact Now
                    </h3>
                    <p className="text-gray-200 text-xs xs:text-sm sm:text-base md:text-lg lg:text-sm xl:text-base px-1">
                      Click here to start your lessons
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          className="absolute left-2 xs:left-3 sm:left-4 md:left-6 top-1/2 transform -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full p-2 sm:p-3 transition duration-300"
          onClick={prevSlide}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 xs:w-5 xs:h-5 sm:w-6 sm:h-6 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <button
          className="absolute right-2 xs:right-3 sm:right-4 md:right-6 top-1/2 transform -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full p-2 sm:p-3 transition duration-300"
          onClick={nextSlide}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 xs:w-5 xs:h-5 sm:w-6 sm:h-6 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>

        {/* Indicators */}
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-20 flex space-x-2">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`w-2 h-2 rounded-full transition-all ${
                index === currentSlide ? "bg-white w-4" : "bg-white/60"
              }`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;
